module.exports = __webpack_public_path__ + "img/person_wanghui.db01b5c8.jpg";